<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Security</h1>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>

          <div class="card-body">
            <div class="panel panel-default bg-light p-3 rounded mb-3">
              <div class="panel-body align-items-center">
                <div class="switch-row">
                  <label class="switch-label"
                    ><i class="fas fa-hat-cowboy-side pc mr-2"></i> DDoS</label
                  >
                </div>
                <label class="switch">
                  <input
                    type="checkbox"
                    @click="changeSecurity('ddos', 'saveDdos')"
                    v-model="list.ddos"
                    id="ddos"
                  />
                  <div class="slider round"></div>
                </label>
              </div>
            </div>

            <div class="panel panel-default bg-light p-3 rounded mb-3">
              <div class="panel-body">
                <div class="switch-row">
                  <label class="switch-label"
                    ><i class="fas fa-shield-alt pc mr-2"></i> VPN Passthrough</label
                  >
                </div>
                <label class="switch">
                  <input
                    type="checkbox"
                    @click="changeSecurity('passthrough', 'changePassthrough')"
                    v-model="list.passthrough"
                    id="passthrough"
                  />
                  <div class="slider round"></div>
                </label>
              </div>
            </div>

            <div class="panel panel-default bg-light p-3 rounded mb-3">
              <div class="panel-body">
                <div class="switch-row">
                  <label class="switch-label"
                    ><i class="fas fa-cog pc mr-2"></i> Flow Offload
                    <span class="mute"> </span
                  ></label>
                </div>
                <label class="switch">
                  <input
                    type="checkbox"
                    @click="changeSecurity('flow_offload', 'changeFlowOffload')"
                    v-model="list.flow_offload"
                    id="flow_offload"
                  />
                  <div class="slider round"></div>
                </label>
              </div>
            </div>

            <!-- <div class="panel panel-default bg-light p-3 rounded mb-3">
              <div class="panel-body">
                <div class="switch-row">
                  <label class="switch-label"
                    ><i class="fas fa-external-link-square-alt pc mr-2"></i> DNS
                    Redirection</label
                  >
                </div>
                <label class="switch">
                  <input
                    type="checkbox"
                    @click="
                      changeSecurity('dns_redirection', 'changeDNSRedirection')
                    "
                    v-model="list.dns_redirection"
                    id="dns_redirection"
                  />
                  <div class="slider round"></div>
                </label>
              </div>
            </div> -->

            <div class="panel panel-default bg-light p-3 rounded">
              <div class="panel-body">
                <div class="switch-row">
                  <label class="switch-label"
                    ><i class="fas fa-user-alt pc mr-2"></i> Spam Guard</label
                  >
                </div>
                <label class="switch">
                  <input
                    type="checkbox"
                    @click="saveSpamGuard(0)"
                    v-model="list.spamGuard"
                    id="spamGuard"
                  />
                  <div class="slider round"></div>
                </label>
              </div>
            </div>
            <div class="row" v-if="list.spamGuard">
              <div class="form-group mt-3 col-md-8">
                <input
                  v-model="spamGuardInput"
                  @keydown.enter="addSpamGuard"
                  class="form-control spamGuard mb-3"
                  placeholder="Press 'Enter' to add address or domain"
                  id="user_defined_spam"
                />
                <div class="mt-2 d-flex" style="flex-wrap: wrap">
                  <div
                    v-for="(spamGuard, index) in spamGuards"
                    :key="index"
                    class="mr-2 mb-2"
                  >
                    <span
                      @click="removeSpamGuard(index)"
                      class="checkbox-block checkbox-block-box"
                      >{{ spamGuard.toUpperCase() }} <i class="icon-close"></i
                    ></span>
                  </div>
                </div>
                <div>
                  <span
                    @click="predefinedSpamGuard('smtp.gmail.com')"
                    class="mr-2 mb-2"
                    :class="{
                      'checkbox-block-box': true,
                      'checkbox-block': predefinedSpamGuards.includes('smtp.gmail.com'),
                    }"
                  >
                    SMTP.GMAIL.COM
                  </span>
                  <span
                    class="mr-2 mb-2"
                    @click="predefinedSpamGuard('smtp.mail.yahoo.com')"
                    :class="{
                      'checkbox-block-box': true,
                      'checkbox-block': predefinedSpamGuards.includes(
                        'smtp.mail.yahoo.com'
                      ),
                    }"
                  >
                    SMTP.MAIL.YAHOO.COM
                  </span>
                </div>

                <button class="btn mt-2" @click="saveSpamGuard(1)">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import "vue2-datepicker/index.css";
import { mapGetters } from "vuex";

export default {
  name: "DDoS",
  metaInfo: {
    title: "Security | Dotlines",
  },
  components: {},
  data: () => ({
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    api_url: "",
    dateRange: "",
    pre: {},
    is_loading: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,

    checkbox: false,
    predefinedSpamGuards: [],
    spamGuardInput: "",
    spamGuards: [],
  }),
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }
    this.api_url = "/ddos";
    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      // await CommonAPI.getCustomPermission(
      //   "/get-custom-permission-infos?path=api/ddos"
      // ).then((response) => {
      //   if (response.status == 200) {
      //     this.custom_permission_data = response.data;
      //   }
      // });

      // if (!_.isEmpty(this.custom_permission_data)) {
      //   this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
      //     this.custom_permission_data.action_permission,
      //     this.custom_permission_data["create_id_condition"],
      //     this.user_detail,
      //     this.custom_permission_data.enableAdministratorPermissionByDefault
      //   );
      // }

      await this.getList()
        .then((response) => {
          this.list = response.data;
          this.spamGuards = this.list.userDefinedSpam;
          this.predefinedSpamGuards = this.list.predefinedSpamAry;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });

      this.is_loading = false;
    },

    getList: function () {
      return new Promise((resolve, reject) => {
        const params = { accountId: LocalStorage.get("accountId") };
        axios
          .get(this.api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },

    changeSecurity(event, url) {
      const _this = this;
      _this.is_loading = true;
      axios({
        method: "POST",
        url: url,
        data: {
          accountId: LocalStorage.get("accountId"),
          data: !_this.list[event],
        },
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          if (event == "flow_offload") {
            if (!_this.list[event] == 0) {
              if (response.data.code == 400) {
                _this.list[event] = 0;
                _this.$toaster.warning(response.data.message);
                return;
              }

              _this.$toaster.success(
                "Flow offload will impact WAN redundancy and QoS policy.Please disable WAN redundancy and QoS if you have already configured those.):"
              );
            } else {
              _this.$toaster.success(response.data.message);
            }
          } else {
            _this.$toaster.success(response.data.message);
          }
        })
        .catch((errors) => {
          if (errors.response) {
            _this.$toaster.error(errors.response.data.message);
          }
        })
        .finally(() => {
          _this.is_loading = false;
        });
    },

    saveSpamGuard(val) {
      const _this = this;
      let spamGuardStatus;
      if (!val) {
        if (!this.list.spamGuard) return;
        _this.spamGuards = [];
        spamGuardStatus = !_this.list.spamGuard;
      } else {
        spamGuardStatus = _this.list.spamGuard;
        if (this.spamGuardInput) {
          this.addSpamGuard();
        }
      }
      _this.is_loading = true;
      axios({
        method: "POST",
        url: "saveSpamGuard",
        data: {
          accountId: LocalStorage.get("accountId"),
          userDefinedSpam: _this.spamGuards.toString(),
          preDefinedSpam: this.predefinedSpamGuards,
          spamGuard: spamGuardStatus,
        },
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          _this.$toaster.success(response.data.message);
        })
        .catch((errors) => {
          if (errors.response) {
            _this.$toaster.error(errors.response.data.message);
          }
        })
        .finally(() => {
          _this.is_loading = false;
        });
    },
    addSpamGuard() {
      if (this.spamGuardInput.trim() !== "") {
        this.spamGuards.push(this.spamGuardInput.trim());
        this.spamGuardInput = "";
      }
    },
    removeSpamGuard(index) {
      this.spamGuards.splice(index, 1);
    },

    predefinedSpamGuard(val) {
      const index = this.predefinedSpamGuards.indexOf(val);
      if (index === -1) {
        this.predefinedSpamGuards.push(val);
      } else {
        this.predefinedSpamGuards.splice(index, 1);
      }
    },
  },
  /* created() {
            this.$emit("update:layout", MasterLayout);
          }, */
};
</script>

<style>
.panel-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.spamGuard {
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.remove-tag {
  margin-left: 5px;
  cursor: pointer;
}

.checkbox-block-box {
  padding: 5px 10px 3px;
  border-radius: 30px;
  color: #868aa8;
  border: 2px solid #868aa8;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.3s linear;
  display: inline-block;
}

.checkbox-block {
  box-shadow: 0 0 15px -3px #d2d5e7;
  color: #fff;
  border-color: #00a79c;
  background-color: #00a79c;
}
</style>
